
import { mapGetters } from 'vuex';

export default {
  name: 'AppButtonLegacy',
  props: {
    type: {
      type: String,
      default: 'button',
      validator: v => ['button', 'submit', 'dropdown'].includes(v)
    },
    buttonStyle: {
      type: String,
      default: 'basic',
      validator: v =>
        [
          'basic',
          'plain',
          'outline',
          'outline-gray',
          'underline',
          'count',
          'outline-select',
          'custom'
        ].includes(v)
    },
    displayType: {
      type: String,
      default: 'inline',
      validator: v => ['block', 'inline'].includes(v)
    },
    label: {
      type: String,
      default: null
    },
    count: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pushed: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('widget', ['device'])
  }
};
